


































import { Component } from 'vue-property-decorator';
import { Store } from '@/enums/Store';
import { ValidatableInterface } from '@/types/Validatable';
import { Member } from '@/util/Member';
import { Event } from '@/util/Event';
import Validatable from '@/components/Validatable.vue';
import MemberFormItem from '@/components/Member/MemberFormItem.vue';
import { namespace } from 'vuex-class';

const MEMBER = namespace(Store.MEMBER);
const EVENT = namespace(Store.EVENT);
const App = namespace(Store.APP);

@Component({
  components: { MemberFormItem }
})
export default class MemberForm extends Validatable {
  @MEMBER.State('members') members!: Member[];
  @MEMBER.Action('addMember') pushMember!: (member: Member) => void;
  @EVENT.Getter('selectedEventObject') event!: Event;
  @App.State('promoterId') promoterId!: number;

  created(): void {
    if (this.members.length == 0) {
      this.addMember();
    }
  }

  async addMember() {
    if (this.$refs.members && (this.$refs.members as MemberFormItem[]).length > 0) {
      for (const member of this.$refs.members as MemberFormItem[]) {
        member.collapsed = true;
      }
    }

    const ticketCategory = this.event.ticketCategories[0];
    const member = Member.create(ticketCategory);
    await this.validate();
    this.pushMember(member);
  }

  async validate() {
    if (this.members.length == 0) {
      return false;
    }

    const validations = [];

    for (const ref of this.$refs.members as any[]) {
      if (typeof ref.validate === 'function') {
        const result = await (ref as ValidatableInterface).validate();
        validations.push(result);
        if (!ref.valid) {
          ref.collapsed = false;
        }
      }
    }

    const isValid = validations.reduce((result: boolean, entry: boolean) => {
      return result && entry;
    }, true);

    return isValid;
  }
}
